import { WEB_URL } from "@/config/endpoints";
import IMAGES from "@/public/assets/img";


export default {
  SeoContent:{
    title: "Credlix programa de socios",
    url: WEB_URL+'/es-mx/partner-program',
    name:'description',
    description:'Empodera a tus clientes con capital instantáneo, sin garantías.',
    keyword: 'Programa de socios', 
    imagePath:IMAGES.HOMEIMG.bigLogoNew.src
  },
  banner: {
    bannerHeading:
      "Destácate con tus clientes con el Capital de Trabajo Instantáneo de Credlix​",
    imagePath: IMAGES?.partnerProgram?.partnerlogoES,
  },
  partnerBenefitsText: {
    imagePath: IMAGES?.partnerProgram?.partnerGrowES,
    subheadline:
      "Empodera a tus clientes con capital instantáneo, sin garantías.",
    description:
      "Como socio, no solo eres un participante más; eres un actor clave en una comunidad que valora la innovación y la excelencia. Con Credlix Xcelerate, tendrás acceso a recursos que impulsan el éxito.",
    partnerbg:
      "<span style='background-color: #FFD700; color: #022B5C;padding: 0px 5px;'>Beneficios</span> para los socios",
  },

  partnerBenefits: [
    {
      title: "Gana altas comisiones",
      description:
        "ofreciendo soluciones de financiamiento de vanguardia, sin garantías. Las tasas más bajas en descuento de facturas.",
      icon: IMAGES?.partnerProgram?.Earnlogo,
    },
    {
      title: "Comienza a ganar",
      description:
        "Acceso e incorporación rápida y sin problemas desde el primer día. Desembolso de fondos más rápido.",
      icon: IMAGES?.partnerProgram?.startEarning,
    },
    {
      title: "Impulsa tu negocio",
      description:
        "Beneficiate del apoyo dedicado a los socios y de las oportunidades de co-marketing.",
      icon: IMAGES?.partnerProgram?.boostBusiness,
    },
    {
      title: "Red global",
      description:
        "Aprovecha la red global de Credlix para desbloquear nuevas oportunidades de negocio y crecimiento.",
      icon: IMAGES?.partnerProgram?.networklogo,
    },
  ],

  Partnership: "Trayectoria de asociación​",
  PartnershipData: [
    {
      id: 1,
      title: "Únete a Credlix Xcelerate",
      descriptionHeading: "Regístrese: ",
      description:
        "Desbloquea apoyo personalizado y comienza a ganar con cada acuerdo.",
      isActive: true,
      image: IMAGES?.partnerProgram?.signupES,
    },
    {
      id: 2,
      title: "Conéctanos con tus clientes",
      descriptionHeading: "Incorporación sin complicaciones: ",
      description:
        "Nosotros manejamos el proceso, tu disfruta de las recompensas.",
      descriptionHeading2: "Impulsa tu negocio: ",
      description2:
        "Ofrece a tus clientes soluciones de financiamiento de primer nivel.",
      isActive: false,
      image: IMAGES?.partnerProgram?.connect,
    },
    {
      id: 3,
      title: "Cosecha los frutos del éxito",
      descriptionHeading: "Red global: ",
      description: "Acceso a nuevas oportunidades en más de 90 países.",
      descriptionHeading2: "Gana más: ​",
      description2:
        "Disfruta de comisiones competitivas y bonificaciones exclusivas.",
      isActive: false,
      image: IMAGES?.partnerProgram?.rewardspartner,
    },
  ],

  GlobalExpansion: {
    heading:
      "Desde tu localidad hasta una <span style='font-weight: 700;'>expansión global</span>",
    imagePath: IMAGES?.partnerProgram?.globalImage,
  },
  mainContent: {
    sections: [
      {
        headline: "Alcance extenso",
        description:
          "Con oficinas en Singapur, USA, India, EAU y México, Credlix ofrece soporte y experiencia localizados para clientes en todo el mundo.",
      },
      {
        headline: "Asociaciones impactantes",
        description:
          "Atendiendo a más de 700 empresas, más de 20,000 proveedores, y más de 500,000 pymes, Credlix está comprometido con fomentar el crecimiento sostenible y la resiliencia.",
      },
      {
        headline: "Impulsando la innovación",
        description:
          "A través de nuestra plataforma digital y procesos sin interrupciones, empoderamos a las empresas para prosperar en el panorama siempre cambiante del comercio global.",
      },
    ],
  },

  statistics: [
    {
      icon: IMAGES?.partnerProgram?.funds,
      title: "$500+ millones",
      description: "de fondos desembolsados",
    },
    {
      icon: IMAGES?.partnerProgram?.staffing,
      title: "5000+",
      description: "pymes incorporadas",
    },
    {
      icon: IMAGES?.partnerProgram?.cities,
      title: "120+",
      description: "ciudades en todo el mundo",
    },
  ],

  boostEarnings: {
    exportHeading:
      "Aumenta tus ganancias con soluciones financieras diversificadas​",
    exportSubHeading:
      "OFRECE A TU CLIENTE HASTA EL <span style='font-weight: 700;'> 90% </span> DEL VALOR DE LA FACTURA EN <span style='font-weight: 700;'>48 HORAS​</span>",
  },

  forExporterMenuItems: [
    {
      name: "Factoraje de exportación",
      href: "/export-factoring",
      text: "Obten hasta el 90% del valor de la factura al momento del envío.",
      src: IMAGES.globalBuyer.exportBuyer,
    },
    {
      name: "Financiamiento de canales",
      href: "",
      text: "Habilita el financiamiento para tus distribuidores a través de NBCs e instituciones financieras.",
      src: IMAGES.partnerProgram.FinanciamientoES,
    },
  ],

  FormData: {
    imagePath: IMAGES?.partnerProgram?.tenxFasterES,
    Company: "Compañía*",
    Email: "correo electrónico*",
    name: "Nombre*",
    lastName: "Apellido*",
    Mobile: "Número de teléfono*",
    Submitbtn: "Aplica Ahora",
    nextBtn: "Siguiente",
    ThankYou: "Envío exitoso: Gracias por su interés.",
    requiredMessage: "Este campo es obligatorio.",
    emailMessage: "Correo electrónico no válido",
    phoneMessage: "El número de teléfono no es válido",
    phoneMessage2: "El número de teléfono no debe comenzar con 0, 1, 2, 3.",
    allErrorMsg: "Por favor complete los campos requeridos",
    selectPlaceholder: "Seleccionar",
    franchise: '¿Cuentas con algún tipo de franquicia?*',
    broker: '¿Cuánto tiempo tienes como bróker o asesor financiero?*',
    factoring: '¿Has trabajado con servicios de financiamiento como el factoraje?*',
    portfolio: '¿Cuántos clientes tienes en tu cartera? (Aproximadamente)*',
    portfolioInvoice:'¿Cuentas con cartera de clientes que exporten o facturen en USD ?*',
    franchiseName: 'Por favor mencione el nombre de la franquicia',
  },

  channelPartnerLogoHeading: "Nuestros Aliados",
  channelPartnerLogo:[
    {
      image: IMAGES?.partnerProgram?.thrivex,
      id: 1,
      alt: "Impulsohd"
    },
    {
      image: IMAGES?.partnerProgram?.gestiónfinanciera,
      id: 2,
      alt: "Thrivex"
    },
    {
      image: IMAGES?.partnerProgram?.impulsoHd,
      id: 3,  
      alt: "Gestion"
    },
  ]
};
